import type { ReactNode } from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import MyApes from "./MyApes"
import TraitStats from "./TraitStats"
import MintStatus from "./MintStatus"
import TopApes from "./TopApes"
import collection from "./data/collection.json"

const Section = ({ title, subtitle, children }: { title: string, subtitle?: string, children: ReactNode }) => (
	<Box component="section" sx={{ mt: { xs: 7, md: 10 } }}>
		<Typography variant="h4" component="h2">{title}</Typography>
		{subtitle && <Typography color="text.secondary" sx={{ mt: .5 }}>{subtitle}</Typography>}
		<Box sx={{ mt: 3 }}>{children}</Box>
	</Box>
)

const Home = () => (
	<>
		<Box sx={{ textAlign: "center" }}>
			<Typography variant="h2" component="h1" sx={{ fontSize: { xs: "2.25rem", md: "3.5rem" } }}>
				Your apes, <Box component="span" sx={{ color: "secondary.main" }}>verified</Box>.
			</Typography>
			<Typography color="text.secondary" sx={{ mt: 2, maxWidth: 560, mx: "auto", fontSize: "1.1rem" }}>
				Connect your Solana wallet to see your Bored Ape Pastels with their traits and rarity rank,
				or scan the QR code on any ape's tag.
			</Typography>
			<MintStatus />
		</Box>
		<Section title="My apes">
			<MyApes />
		</Section>
		<Section title="Top 10 rarest" subtitle="Discovered apes have been minted; the rest are still waiting in the candy machine.">
			<TopApes />
		</Section>
		<Section title="Collection traits" subtitle={`Counts cover all ${collection.total} apes, minted or still available.`}>
			<TraitStats />
		</Section>
	</>
)

export default Home
